import { render, staticRenderFns } from "./dataPanel.vue?vue&type=template&id=d24c1d6e&scoped=true&"
import script from "./dataPanel.vue?vue&type=script&lang=js&"
export * from "./dataPanel.vue?vue&type=script&lang=js&"
import style0 from "./dataPanel.vue?vue&type=style&index=0&id=d24c1d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24c1d6e",
  null
  
)

export default component.exports